/**************************************************************************************************************************************************
*   MODULE NAME     :  Administration
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  15-02-2021
*   DESCRIPTION     :  Component to load Administration Tabs
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import React from "react";
import { Container,Tabs, Tab } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import LockedAbstracts from './LockedAbstracts';
import MasterDataManagement from './MasterDataManagement';
import UsersManagement from './UsersManagement';
import { } from '../common/MessagesPool';
import "./Administration.css";

class Administration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    /**
     * Function to initiate life cycle method.
     */
    componentDidMount() {

    }
    render() {
        return (
            <>
                <div className="CommonWrap">
                    <Container fluid>
                        <div className="headerpart">
                            <h1>Administration</h1>
                        </div>
                        <div className="admin-common">
                            <Tabs defaultActiveKey="masterDataManagement" id="admintab">
                                <Tab eventKey="masterDataManagement" title="Master Data Management">
                                    <MasterDataManagement/>
                                </Tab>
                                <Tab eventKey="lockedAbstracts" title="Locked Abstracts" >
                                   <LockedAbstracts/>
                                </Tab>
                                <Tab eventKey="usersManagement" title="User Details">
                                    <UsersManagement/>
                                </Tab>
                            </Tabs>
                        </div>
                    </Container>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {

        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Administration));
